import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Tarjeta } from "../../models/trust/empleado/Tarjeta";
import { TarjetaService } from "../../service/trust/empleado/TarjetaService";

export const DetalleTarjeta = ({ toast, id, permss, soloLectura }) => {

    const omodel = new Tarjeta();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);

    const tarjetaSrv = new TarjetaService();
    const tablaTarjeta = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inText, inCalendar, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaTarjeta.lazyParams, id]);

    const loadLazyData = () => {
        tablaTarjeta.setLoading(true);
        const _params = { ...tablaTarjeta.lazyParams, idp: id };
        tarjetaSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaTarjeta.setTotalRecords(res.data.total);
            tablaTarjeta.setData(res.data.registros);
        }).finally(() => tablaTarjeta.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.fecha_expedicion = generic.dateToString(data.fecha_expedicion);

        const request = getValues('id') == null
            ? tarjetaSrv.nuevo(data)
            : tarjetaSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        tarjetaSrv.consultar(idReg).then(res => {
            const _data = res.data.tarjeta_credito;
            _data.fecha_expedicion = generic.stringToDate(_data.fecha_expedicion);
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar esta tarjeta de crédito?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                tarjetaSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_tarjeta" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Tarjetas de Crédito
            </span>
        </div>
    );

    return (
        <div className="componente-detalle-tarjeta">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_tarjeta" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaTarjeta} datos={tablaTarjeta.data} totalRegistros={tablaTarjeta.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nueva Tarjeta de Crédito" : "Editar Tarjeta de Crédito"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '580px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-credit-card text-primary"></i>
                                    TARJETA DE CRÉDITO
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inText('emisor', { icon: 'pi pi-building' }, 6)}
                        {inText('numero_tarjeta', { icon: 'pi pi-credit-card' }, 6)}

                        {inCalendar('fecha_expedicion', {}, 6)}
                        {inNumber('cupo_credito', 2, false, { prefix: '$ ' }, 6)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
